<script>
export default {
    name: 'NewDetails',

    props: {
        data: Object,
    },

    data() {
        return {
            open: false,
        };
    },

    computed: {
        details() {
            const lines = [];
            for (const prop of Object.keys(this.data)) {
                lines.push(`${prop}: ${this.data[prop]}`);
            }
            return lines;
        },
    },

    methods: {
        toggle() {
            this.open = !this.open;
        },
    },
};
</script>

<template>
    <div class="new-details" @click="toggle()" :class="{ open: open }">
        <div class="header">
            <span>Details</span>
            <i class="fa fa-caret-down"></i>
        </div>
        <div class="body">
            <span v-for="(detail, index) in details" :key="index">{{
                detail
            }}</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use 'sass:color';
@use '../../../palette.scss' as *;

.new-details {
    position: relative;

    &:hover {
        cursor: pointer;
    }

    &.open {
        .header {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;

            .fa-caret-down {
                transform: rotate(180deg);
            }
        }

        .body {
            height: auto;
            padding: 10px;
            border: 2px solid $theme-light-grey;
            border-top: none;
        }
    }

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        background-color: $theme-light-grey;
        color: $theme-dark-grey;
        border-radius: 3px;
        font-size: 1em;

        .fa-caret-down {
            transition: transform 0.5s;
        }
    }

    .body {
        display: flex;
        flex-direction: column;
        border-bottom-right-radius: 3px;
        border-bottom-left-radius: 3px;
        color: $theme-grey;
        padding: 0;
        height: 0;
        padding: 0 10px;
        overflow: hidden;
    }
}
</style>
